import { render, staticRenderFns } from "./EditStudio.vue?vue&type=template&id=5386bc8e&scoped=true&"
import script from "./EditStudio.vue?vue&type=script&lang=js&"
export * from "./EditStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386bc8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5386bc8e')) {
      api.createRecord('5386bc8e', component.options)
    } else {
      api.reload('5386bc8e', component.options)
    }
    module.hot.accept("./EditStudio.vue?vue&type=template&id=5386bc8e&scoped=true&", function () {
      api.rerender('5386bc8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/studios/EditStudio.vue"
export default component.exports